import React, { useState } from 'react';
import Button from '../../../shared/components/ui/Button';
import { Users, Building2, UserCheck, CheckCircle } from 'lucide-react';
import Modal from '../../../shared/components/ui/Modal';

const BulkActionModal = ({ isOpen, onClose, onActionSelect, isSubmitting = false }) => {
  const [selectedAction, setSelectedAction] = useState(null);

  const actionOptions = [
    {
      id: 'assign_employee',
      title: 'Assign Employee',
      description: 'Assign employees to selected tasks',
      icon: <Users size={24} className="text-blue-600" />,
      color: 'bg-blue-50 border-blue-200 hover:bg-blue-100'
    },
    {
      id: 'assign_contractor',
      title: 'Assign Contractor',
      description: 'Assign contractors to selected tasks',
      icon: <Building2 size={24} className="text-green-600" />,
      color: 'bg-green-50 border-green-200 hover:bg-green-100'
    },
    {
      id: 'assign_architect',
      title: 'Assign Architect',
      description: 'Assign architects to selected tasks',
      icon: <UserCheck size={24} className="text-purple-600" />,
      color: 'bg-purple-50 border-purple-200 hover:bg-purple-100'
    },
    {
      id: 'complete_task',
      title: 'Complete Task',
      description: 'Mark selected tasks as completed',
      icon: <CheckCircle size={24} className="text-orange-600" />,
      color: 'bg-orange-50 border-orange-200 hover:bg-orange-100'
    }
  ];

  const handleActionSelect = (actionId) => {
    setSelectedAction(actionId);
  };

  const handleConfirm = () => {
    if (selectedAction) {
      onActionSelect(selectedAction);
      setSelectedAction(null);
    }
  };

  const handleClose = () => {
    setSelectedAction(null);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      width={60}
      name="Bulk Actions"
      isDirty={true}
      confirmOnClose={true}>
      <div className="pt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          {actionOptions.map((action) => (
            <div
              key={action.id}
              onClick={() => handleActionSelect(action.id)}
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                selectedAction === action.id
                  ? `${action.color} ring-2 ring-offset-2 ring-current`
                  : `${action.color} hover:shadow-md`
              }`}>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">{action.icon}</div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-gray-900">{action.title}</h4>
                  <p className="text-xs text-gray-600 mt-1">{action.description}</p>
                </div>
                {selectedAction === action.id && (
                  <div className="flex-shrink-0">
                    <div className="w-5 h-5 bg-current rounded-full flex items-center justify-center">
                      <div className="w-2 h-2 bg-white rounded-full"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end space-x-3">
          <Button
            type="button"
            onClick={handleClose}
            displayType="secondary"
            disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="button" onClick={handleConfirm} disabled={!selectedAction || isSubmitting}>
            {isSubmitting ? 'Processing...' : 'Continue'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BulkActionModal;
